var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 14H0.25V0H16V14Z",
    stroke: "#E5E7EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_431_18079)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_431_18079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1875 6.98359V6.5625V5.6875C11.1875 5.44688 10.9906 5.25 10.75 5.25H9.875H9.4375H8.16602C6.77422 5.25 5.59844 6.16602 5.20469 7.42656C5.11445 7.16953 5.0625 6.88516 5.0625 6.5625C5.0625 4.86992 6.43242 3.5 8.125 3.5H9.4375H9.875H10.75C10.9906 3.5 11.1875 3.30312 11.1875 3.0625V2.1875V1.76641L14.0859 4.375L11.1875 6.98359ZM9.4375 6.5625H9.875V7.875C9.875 8.35898 10.266 8.75 10.75 8.75H10.8512C11.0672 8.75 11.275 8.6707 11.4363 8.52578L15.2371 5.10508C15.4449 4.91914 15.5625 4.65391 15.5625 4.375C15.5625 4.09609 15.4449 3.83086 15.2371 3.64492L11.4582 0.243359C11.2832 0.0875 11.059 0 10.8238 0C10.2988 0 9.875 0.423828 9.875 0.948828V2.1875H9.4375H8.5625H8.125C5.70781 2.1875 3.75 4.14531 3.75 6.5625C3.75 8.21406 4.69609 9.27227 5.49727 9.86836C5.65859 9.98867 5.81172 10.0898 5.95391 10.1746C6.07422 10.2484 6.18633 10.3086 6.2793 10.3551C6.37227 10.4016 6.44883 10.4371 6.50352 10.4617C6.56367 10.4891 6.6293 10.5 6.69766 10.5H6.76602C7.03398 10.5 7.25273 10.2812 7.25273 10.0133C7.25273 9.8 7.10781 9.61133 6.93555 9.48008C6.92461 9.47188 6.91641 9.46641 6.90547 9.4582C6.85898 9.42812 6.8125 9.38984 6.76875 9.34609C6.74687 9.32422 6.72227 9.30234 6.70039 9.275C6.67852 9.24766 6.65664 9.22305 6.63477 9.1957C6.58555 9.12734 6.53906 9.05078 6.49805 8.96328C6.42695 8.79922 6.38047 8.59961 6.38047 8.35078C6.38047 7.36367 7.18164 6.55977 8.17148 6.55977H8.5625H9.4375V6.5625ZM2.21875 0.875C1.13047 0.875 0.25 1.75547 0.25 2.84375V12.0312C0.25 13.1195 1.13047 14 2.21875 14H11.4062C12.4945 14 13.375 13.1195 13.375 12.0312V10.2812C13.375 9.91758 13.0824 9.625 12.7188 9.625C12.3551 9.625 12.0625 9.91758 12.0625 10.2812V12.0312C12.0625 12.3949 11.7699 12.6875 11.4062 12.6875H2.21875C1.85508 12.6875 1.5625 12.3949 1.5625 12.0312V2.84375C1.5625 2.48008 1.85508 2.1875 2.21875 2.1875H3.96875C4.33242 2.1875 4.625 1.89492 4.625 1.53125C4.625 1.16758 4.33242 0.875 3.96875 0.875H2.21875Z",
    fill: "#E6E6E6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_431_18079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.75,
    height: 14,
    fill: "white",
    transform: "translate(0.25)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_431_18079"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.25 0H16V14H0.25V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.01de133c0ff47d2c4dbc05218b63ccd0.svg";
export { ForwardRef as ReactComponent };